import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.499 3.067a.7.7 0 0 1 .38.805L10.9 7.725H14a.7.7 0 0 1 .584 1.086l-5.2 7.875a.7.7 0 0 1-1.268-.535l1.015-4.663H6a.7.7 0 0 1-.564-1.115l5.2-7.087a.7.7 0 0 1 .863-.22Zm-4.117 7.02H10a.7.7 0 0 1 .684.85l-.403 1.85L12.7 9.124H10a.7.7 0 0 1-.678-.872l.314-1.238-2.254 3.073Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
